import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonImg } from '@ionic/react';
import { FC } from 'react';

interface CampaingCardProps {
    title: string,
    id: string,
    imageUrl?: string,
    description: string,
    navigate: any
}

const CampaignCard: FC<CampaingCardProps> = ({ title, id, imageUrl, description, navigate}) => {
    return (
        <IonCol sizeXs='12' sizeSm='6' sizeMd='4'>
            <IonCard className='fundraiserCard' mode='md'>
                <IonCardHeader>
                    <div className='img16by9-container'>
                    <IonImg className='img16by9' src={imageUrl ? imageUrl : process.env.PUBLIC_URL + '/assets/placeholder_image.jpg'}></IonImg>
                    </div>
                <IonCardTitle class='ion-text-uppercase'>{title}</IonCardTitle>
                </IonCardHeader>
                <IonCardContent className=''>
                    <p>
                    {`${description.substring(0, 96)}...`}
                    </p>
                    <IonButton className='ion-margin-bottom' size='small' fill='outline' style={{float:'right'}} onClick={e=>navigate(id)}>Details</IonButton>
                    </IonCardContent>
            </IonCard>
        </IonCol>

    )
}

export default CampaignCard;